"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _filterDropdown = _interopRequireDefault(require("../filters/filterDropdown"));
var _tableContext = require("../../Context/tableContext");
var _Helpers = require("../../Helpers");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function FilterDropdownHOC(props) {
  var _useState = (0, _react.useState)(_tableContext.eventHub.getState('locale') || {}),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    locale = _useState2[0],
    setLocale = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    filters = _useState4[0],
    setFilters = _useState4[1]; // { title : [ "test1", "test2"]}

  var prefixCls = props.prefixCls,
    column = props.column;
  var filterDropdown = column.filterDropdown;
  var dataIndex = column.dataIndex;
  (0, _react.useEffect)(function () {
    var unsubscriber = [_tableContext.eventHub.on('update.locale', setLocale), _tableContext.eventHub.on('update.filters', checkFilter)];
    return function () {
      unsubscriber.forEach(function (fn) {
        return fn();
      });
    };
  }, []);
  function checkFilter(filterParams) {
    if (Object.keys(filterParams).length == 0) {
      setFilters({});
    }
  }
  function getColumnKey(column, index) {
    return column.dataIndex || index;
  }
  function getValue(type, nextFilters) {
    var value = nextFilters[0] || '';
    if (type === 'searchableFilter') {
      value = nextFilters;
    }
    return value;
  }

  // nextFilters = [0 : 'Gelen Eft', 1: 'giden Eft'] => string array
  function getValueWithColumnType(type, column, nextFilters) {
    if (nextFilters.length === 0) return '';
    var value = getValue(type, nextFilters);
    var expandable = _tableContext.eventHub.getState('expandable') || {};
    var preparedProps = {
      onExpandByFilter: expandable.onExpandByFilter || function () {}
    };
    var filters = {
      ibanSearchFilter: [type, preparedProps, column, nextFilters || ''],
      dateFilter: [type, preparedProps, column, nextFilters || ''],
      timeFilter: [type, preparedProps, column, nextFilters || ''],
      numberFilter: [type, preparedProps, column, nextFilters || ''],
      currencyFilter: [type, preparedProps, column, nextFilters || ''],
      searchableFilter: [type, preparedProps, column, nextFilters || '']
    };
    if (filters[type]) return filters[type];
    return value || '';
  }
  function handleFilter(column, nextFilters) {
    var filterType = _Helpers.Utils.getFilterType(column);
    column.filterFn = filterType;
    var value = getValueWithColumnType(filterType, column, nextFilters);
    var stateFilters = _tableContext.eventHub.getState('filters');
    var _filters = _objectSpread({}, stateFilters);
    if (value == '') {
      delete _filters[getColumnKey(column)];
    } else {
      _filters[getColumnKey(column)] = value;
    }

    // context üzerine kayıt eder.
    setFilters(_filters);
    // header.column.setFilterValue(value);
    _tableContext.eventHub.emit('update.filters', _filters);
    // filtre uygulanarak expand edilen column bilgileri var ise bunları tablo tarafından bir methoda giderek temizler.
    // if (nextFilters.length === 0) table.options?.meta?.resetExpandedColumn();
    // filtre ikonunundaki maviligi yönetmek icin
  }
  if (filterDropdown) {
    var colValues = dataIndex in filters ? filters[dataIndex] : [];
    var _colValues = (0, _slicedToArray2.default)(colValues, 4),
      _colValues$ = _colValues[3],
      colFilters = _colValues$ === void 0 ? [] : _colValues$;
    return /*#__PURE__*/_react.default.createElement(_filterDropdown.default, {
      locale: locale,
      column: column,
      selectedKeys: colFilters,
      confirmFilter: handleFilter,
      prefixCls: "".concat(prefixCls, "-filter"),
      dropdownPrefixCls: "".concat(prefixCls, "-dropdown"),
      key: "filter-dropdown",
      data: props.data || [],
      scroll: props.scroll
    });
  }
  return null;
}
var _default = exports.default = FilterDropdownHOC;